import { ConfirmationDialogService } from 'src/app/services/confirmation-dialog.service';
import {
  Component,
  ElementRef,
  forwardRef,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Renderer2,
  ViewEncapsulation,
  inject
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';

import { from, Subscription } from 'rxjs';
import { ApiConstants } from 'src/app/base/api-constants';
import { HttpBaseService } from 'src/app/base/http-base.service';
import { picklist } from 'src/app/STORE/selectors/propertypane.selector';
import { PickupListService } from '../pickup-list/pickup-list.service';
import { setPickupProperties } from 'src/app/STORE/actions/propertypane.actions';
import { AppLoaderService } from 'src/app/services/app-loader.service';
import { DMConstants, nodeType } from 'src/app/pages/designs/data-model/data-model.component';
import { ReferenceUtilService } from '../reference-tree-view/reference-util.service';
import { setFieldsForTable } from 'src/app/STORE/actions/services.actions';
import { UtilService } from 'src/app/services/util.service';
import { GlobalConstants } from 'src/app/base/global.constants';
@AutoUnsubscribe({ arrayName: 'subscriptions' })
@Component({
  selector: 'vb-dropdown-with-indexdesigner',
  templateUrl: './dropdown-with-indexdesigner.component.html',
  styleUrls: ['./dropdown-with-indexdesigner.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DropdownWithIndexdesignerComponent),
      multi: true
    }
  ],
  encapsulation: ViewEncapsulation.None,
  standalone: false  //NOSONAR
})
export class DropdownWithIndexdesignerComponent implements OnInit, OnDestroy, OnChanges {
  private confirmationDialogService = inject(ConfirmationDialogService);
  private translate = inject(TranslateService);
  private renderer = inject(Renderer2);
  private elementRef = inject(ElementRef);
  private store = inject(Store);
  private util = inject(UtilService);
  private bs = inject(HttpBaseService);
  private referenceUtil = inject(ReferenceUtilService);

  static readonly fullWord = 'yes';
  static readonly notSearchable = 'no';
  @Input() formData: any = null;
  @Input() tableIdMap: any = null;
  @Input() fieldIdMap: any = null;
  @Input() pickList: any = null;
  @Input() disableField = false;
  @Input() formFields: any = null;
  @Input() dataModelOrders: any = null;
  @Input() currentNode: any = null;
  showCreateIndex = false;
  disabled = false;
  @Input() element: any;
  @Input() config: any;
  ref$: Subscription = new Subscription();
  subscriptions: Subscription[] = [];
  private modelValue: any;
  popupOpened = false;
  private onChange: (m: any) => void;
  private onTouched: (m: any) => void;
  searchValue: any;
  dataSub: Subscription;
  isLoading = false;

  disableSearchable() {
    if (
      (this.formData.purpose && this.formData.purpose === 'REFERENCE') ||
      this.formData.f_type?.toLowerCase() === 'auto-number' ||
      (this.formData?.name === GlobalConstants.isActiveField && this.formData?.sysGen) ||
      (this.formData?.f_sysF && this.formData?.name !== 'Sid' && this.formData?.name !== 'Pid')
    ) {
      this.disableField = true;
    }
  }

  ngOnInit(): void {
    this.dataSub = this.store.select(picklist).subscribe((picklistRes) => {
      if (picklistRes) {
        this.pickList = picklistRes;
        this.isLoading = false;
      }
    });
    this.subscriptions.push(this.dataSub);
    this.disableSearchable();
  }

  ngOnChanges() {
    this.disableSearchable();
  }

  get model() {
    return this.modelValue;
  }

  writeValue(value: any): void {
    this.modelValue = value;
    this.searchValue = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  set(value: any) {
    this.modelValue = value;
    this.searchValue = value;
    this.onChange(this.modelValue);
  }

  setValue(value) {
    if (value) {
      if (typeof value === 'string') {
        if (value.includes(this.formData.sid)) {
          this.formData.f_indexed = true;
          this.set(this.searchValue);
          this.showCreateIndex = false;
          return;
        }
      }
    }
    this.searchValue = DropdownWithIndexdesignerComponent.notSearchable;
    this.showCreateIndex = false;
  }

  setDisabledState(isDisabled: boolean) {
    this.renderer.setProperty(this.elementRef.nativeElement, 'disabled', isDisabled);
    this.disabled = isDisabled;
  }

  getPickuplist() {
    this.store.dispatch(setPickupProperties({ picklist: null }));
    this.isLoading = true;
    const picklistVal: any = {
      fields: [],
      tables: [],
      primaryFields: [],
      allFields: [],
      noImgFAFields: [],
      indexFields: []
    };
    const fieldInfoSub = this.bs.get(ApiConstants.getFieldInfo, { tableId: this.formData.f_tableId }).subscribe({
      next: (data: any) => {
        try {
          if (data) {
            const primaryFields = data
              .filter((fld) => {
                return (
                  (fld.f_type.toLowerCase() === 'number' ||
                    fld.f_type.toLowerCase() === 'string' ||
                    fld.f_type.toLowerCase() === 'dropdown' ||
                    fld.f_type.toLowerCase() === 'lookup' ||
                    fld.f_type.toLowerCase() === 'datetime' ||
                    fld.f_type.toLowerCase() === 'currency' ||
                    fld.f_type.toLowerCase() === 'date' ||
                    fld.f_type.toLowerCase() === 'double' ||
                    data.f_type.toLowerCase() === 'checkbox' ||
                    fld.f_type.toLowerCase() === 'email' ||
                    fld.f_type.toLowerCase() === 'json' ||
                    fld.f_type.toLowerCase() === 'radio' ||
                    fld.f_type.toLowerCase() === 'color') &&
                  !fld.f_hasMultiVal &&
                  fld.name.toLowerCase() !== 'id'
                );
              })
              .map((fld) => {
                return { sid: fld.sid, name: fld.name };
              });
            const lookupFields = data
              .filter((fld) => {
                return fld.f_searchable !== 'no';
              })
              .map((fld) => {
                return { sid: fld.sid, name: fld.name };
              });
            const noImgFAFields = data
              .filter((fld) => {
                return (
                  fld.f_type.toLowerCase() !== 'image carousel' &&
                  fld.f_type.toLowerCase() !== 'file attachments' &&
                  fld.f_type.toLowerCase() !== 'Checkboxgroup' &&
                  fld.f_type.toLowerCase() !== 'Complex Datatype' &&
                  !fld.f_sysF
                );
              })
              .map((fld) => {
                return { sid: fld.sid, name: fld.name };
              });
            const indexFields = data
              .filter((fld) => {
                return (
                  (fld.f_type.toLowerCase() !== 'image carousel' &&
                    fld.f_type.toLowerCase() !== 'file attachments' &&
                    fld.f_type.toLowerCase() !== 'Checkboxgroup' &&
                    fld.f_type.toLowerCase() !== 'Complex Datatype' &&
                    fld.name.toLowerCase() === 'sid') ||
                  !fld.f_sysF
                );
              })
              .map((fld) => {
                return { sid: fld.sid, name: fld.name };
              });
            picklistVal.indexFields = indexFields;
            picklistVal.noImgFAFields = noImgFAFields;
            picklistVal.fields = lookupFields;
            picklistVal.allFields = data.map((fld) => {
              return { sid: fld.sid, name: fld.fieldname };
            });
            picklistVal.primaryFields = [...primaryFields];
          }
          this.store.dispatch(setPickupProperties({ picklist: picklistVal }));
          this.store.dispatch(setFieldsForTable({ tblFields: data }));
          this.isLoading = false;
        } catch (e) {
          console.error(e);
          this.store.dispatch(setPickupProperties({ picklist: picklistVal }));
          this.isLoading = false;
        }
      },
      error: (error: any) => {
        this.isLoading = false;
      }
    });
  }

  confirmIndexCreation() {
    const message = this.translate.instant('NON_INDEX_FIELD_CONFIRMATION');
    const self = this;
    const confirmationObj = {
      message,
      accept: () => {
        self.showCreateIndex = true;
        self.getPickuplist();
      },
      reject: () => {
        self.set(this.searchValue);
      }
    };
    this.confirmationDialogService.confirm(confirmationObj);
  }

  getReferences() {
    return this.referenceUtil.getReferences({
      modelId: this.formData.sid,
      modelType: 'FIELD',
      actionType: 'UPDATE',
      action: 'UPDATE'
    });
  }

  getSearchReferences(event) {
    this.getReferences().then(
      (value: any) => {
        this.isLoading = false;
        if (value.length > 0) {
          const d = {
            genericAction: 'UPDATE'
          };
          if (this.popupOpened) {
            return;
          }
          this.util.setPopupRestriction(this.popupOpened);
          this.showReferenceTree(event, value, d);
        } else {
          this.confirmSearchChange();
        }
      },
      (error) => {
        this.searchValue = DropdownWithIndexdesignerComponent.fullWord;
      }
    );
  }

  confirmSearchChange() {
    this.set(this.searchValue);
    // let keys = Object.keys(value);
    // let keysLength = keys.length;
    // if (keysLength===0) {

    // } else {
    //   let message = "Before changing the field to non searchable.Remove the field from search configuration in pages";
    //   let confirmationObj = {
    //     message,
    //     acceptLabel: 'OK',
    //     accept: () => {
    //       this.searchValue = DropdownWithIndexdesignerComponent.fullWord;
    //       return;
    //     },
    //     rejectVisible: false,
    //   }
    //   this.confirmationDialogService.confirm(confirmationObj);
    // }
  }

  istransactional(order) {
    const isTabel = order.find((node) => {
      if (!node.title) {
        return false;
      }
      if (
        node.type === nodeType.TABLE &&
        node.data?.sid === this.currentNode.f_tableId &&
        (node.data.t_type === DMConstants.TRANS_ONLY || node.data.t_type === DMConstants.TRANS_ANALY)
      ) {
        return true;
      } else if (node.type === nodeType.GROUP) {
        let val;
        if (node.children) {
          val = this.istransactional(node.children);
        }
        return !!val;
      }
      return false;
    });
    return isTabel;
  }

  handleChange(event) {
    if (this.istransactional(this.dataModelOrders)) {
      this.showCreateIndex = false;
      if (this.searchValue === DropdownWithIndexdesignerComponent.fullWord && !this.formData?.f_indexed) {
        this.confirmIndexCreation();
      } else if (this.searchValue === DropdownWithIndexdesignerComponent.fullWord && this.formData?.f_indexed) {
        this.set(this.searchValue);
      } else {
        this.isLoading = true;
        this.getSearchReferences(event);
      }
    } else {
      this.set(this.searchValue);
    }
  }

  showReferenceTree(nodedata: any, value: any, rawData: any = {}) {
    this.referenceUtil
      .openReferenceTree({ name: 'Search', type: 'Field property' }, value, rawData.genericAction)
      .then((confirmed) => {
        if (confirmed) {
          switch (rawData.genericAction) {
            case 'UPDATE':
              this.confirmSearchChange();
              break;
            default:
              console.log('nothing to call');
          }
        } else {
          // reset to model value
          this.searchValue = this.modelValue;
        }
      })
      .catch(() => {});
  }

  ngOnDestroy(): void {
    if ($(this.elementRef.nativeElement)) {
      $(this.elementRef.nativeElement).remove();
    }
    if (this.dataSub) {
      this.dataSub.unsubscribe();
    }
  }
}



